import { FC, Fragment } from 'react';

import { SmartEnergyOfferResponseRow } from '@dc-be/client/types.gen';
import { Box, Stack, Stretch, Text } from '@sparky';

const Battery: FC<{
  offer: SmartEnergyOfferResponseRow;
}> = ({ offer }) => {
  const amount = (offer.numberOfModules ?? 1) - 1;
  return (
    <Stack direction="row" gap="2" alignX="center">
      <Stack.Item>
        <Stack alignX="center" gap="2">
          <Stack gap="0" direction="column">
            <svg
              width="100%"
              height="auto"
              viewBox={`78 34 222 ${62 + 61 * amount}`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none">
              {/* Start module */}
              <path
                d={`M 78 42 C 78 37 81 34 86 34 H 270 C 275 34 278 37 278 42 V ${95 + 61 * amount} H 78 Z`}
                fill="#8C8B8D"
              />
              <path d="M 79 42 C 79 37.75 81.75 35 86 35 H 260 C 265 35 268 38 268 43 V 94 H 79 Z" fill="#FFF" />
              <circle xmlns="http://www.w3.org/2000/svg" cx="246" cy="57.5" r="11.5" fill="#ECECEC" stroke="#8C8B8D" />
              <circle xmlns="http://www.w3.org/2000/svg" cx="246" cy="57.5" r="8" fill="#8C8B8D" />
              <path
                d={`M 297 40 L 299 34 L 294 34 L 296 40 L 297 40 Z M 296 40 V ${90 + 61 * amount} H 297 V 40 Z M 296 ${90 + 61 * amount} L 294 ${95 + 61 * amount} L 299 ${95 + 61 * amount} L 297 ${90 + 61 * amount} L 296 ${90 + 61 * amount} Z`}
                fill="#000"
              />
              {/* Middle modules */}
              {[...Array(amount)].map((_, i) => (
                <Fragment key={`module-${i}}`}>
                  <path d={`M 79 ${95 + 61 * i} H 268 V ${155 + 61 * i} H 79 Z`} fill="#FFF" />
                </Fragment>
              ))}
            </svg>

            {/* End module */}
            <svg width="100%" height="auto" viewBox="78 335 222 30" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path
                d="M 83 359 L 78 357 L 78 362 L 83 360 L 83 359 Z M 263 360 L 268 362 L 268 357 L 263 359 L 263 360 Z M 83 360 L 263 360 L 263 359 L 83 359 L 83 360 Z M 281.817 355.951 L 276.346 356.847 L 279.653 361.582 L 282.39 356.771 L 281.817 355.951 Z M 293.183 349.264 L 298.653 348.367 L 295.347 343.633 L 292.61 348.444 L 293.183 349.264 Z M 281.979 357.056 L 293.593 348.979 L 293.02 348.159 L 281.407 356.236 L 281.979 357.056 Z"
                fill="#000"
              />
            </svg>
          </Stack>
          <Box paddingRight="8">
            <Text>{`${offer.width || 0} cm`}</Text>
          </Box>
        </Stack>
      </Stack.Item>
      <Stack.Item shrink={false}>
        <Stretch height="true">
          <Stack alignY="justify" direction="column">
            <Stack.Item grow>
              <Stretch height="true">
                <Stack alignY="center">
                  <Box paddingBottom="8">
                    <Text>{`${offer.height || 0} cm`}</Text>
                  </Box>
                </Stack>
              </Stretch>
            </Stack.Item>
            <Text>{`${offer.depth || 0} cm`}</Text>
          </Stack>
        </Stretch>
      </Stack.Item>
    </Stack>
  );
};

export default Battery;
